import { GridRenderEditCellParams, GridRowModes } from '@mui/x-data-grid-pro';
import React, { ChangeEvent, FC } from 'react';
import Checkbox from '@mui/material/Checkbox';

interface IGridColConditionProps {
  params: GridRenderEditCellParams;
  disabled?: boolean;
  onChange?(event: ChangeEvent<HTMLInputElement>, checked: boolean): void;
}

export const GridColInvertedBoolean: FC<IGridColConditionProps> = ({ params, disabled }) => {
  const { api, id, field, value } = params;
  const isEditMode = api.getRowMode(id) === GridRowModes.Edit;

  const checked = value === false;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = !event.target.checked;
    api.setEditCellValue({ id, field, value: newValue }, event);
  };

  return isEditMode ? (
    <Checkbox
      checked={checked}
      disabled={disabled}
      onChange={handleChange}
    />
  ) : (
    <span>{value === false ? 'No' : 'Yes'}</span>
  );
};
